<template>
  <v-app>
    <v-container fluid>
      <!-- Search Form -->
      <v-row>
        <v-col cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">
                Search Form
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-form @submit.prevent="submit">
                  <v-row class="pa-2">

                    <!-- <v-col md="2" cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="From Date"
                        density="compact"
                        prepend-inner-icon="mdi mdi-calendar-month"
                        prepend-icon=""
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="from_date"
                        :error-messages="fromDateError"
                        autocomplete="off"
                        clearable
                      />
                    </v-col>
                    <v-col md="2" cols="12">
                      <v-date-input
                        input-format="dd/mm/yyyy"
                        label="To Date"
                        density="compact"
                        prepend-inner-icon="mdi mdi-calendar-month"
                        prepend-icon=""
                        single-line
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        v-model="to_date"
                        :error-messages="toDateError"
                        autocomplete="off"
                        clearable
                      />
                    </v-col> -->


                    <v-col md="4" cols="12">
                      <v-autocomplete
                        label="Financial Year"
                        v-model="financial_year"
                        :items="getFinancialYearList()"
                        density="compact"
                        variant="outlined"
                        clearable
                        :error-messages="financialYearError"
                        hide-details
                      />
                    </v-col>


                    <v-col lg="2" md="2" cols="12">
                      <v-btn class="bg-brand w-15" type="submit">Search</v-btn>
                    </v-col>
                  </v-row>
                </v-form>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>
      </v-row>

      <!-- Report Table -->
      <v-container fluid style="margin-top: -20px;">
        <v-row>
          <v-col cols="12">
            <v-expansion-panels v-model="panel2">
              <v-expansion-panel>
                <v-expansion-panel-title color="blue-grey-lighten-4" class="panel-header">
                  Budget Variance Report
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                  <v-row class="py-2">
                    <v-col md="4" cols="6">
                      <v-text-field
                        v-model="search"
                        append-inner-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                        density="compact"
                        variant="outlined"
                        bg-color="grey-lighten-4"
                        clearable
                        class="pl-2"
                      />
                    </v-col>
                    <v-col md="4" cols="6">
                      <v-btn-group variant="outlined" density="compact" size="x-small" divided>
                        <v-btn prepend-icon="mdi mdi-download" variant="flat" color="primary" @click="exportToExcel">
                          EXCEL
                        </v-btn>
                        <v-btn prepend-icon="mdi mdi-download" variant="flat" color="red" @click="exportToPDF">
                          PDF
                        </v-btn>
                      </v-btn-group>
                    </v-col>
                  </v-row>

                  <v-data-table
                    :headers="headers"
                    :items="reportData"
                    :loading="loading"
                    v-model:items-per-page="itemsPerPage"
                    :search="search"
                    density="compact"
                    >
                        <!-- Serial -->
                        <template v-slot:item.index="{ index }">
                            {{ index + 1 }}
                        </template>

                        <!-- Amount format -->
                        <template v-slot:item.budget="{ item }">
                            {{ Number(item.budget).toLocaleString() }}
                        </template>

                        <template v-slot:item.actual="{ item }">
                            {{ Number(item.actual).toLocaleString() }}
                        </template>

                        <template v-slot:item.variance="{ item }">
                            <span :class="item.variance >= 0 ? 'text-success' : 'text-red'">
                            {{ Number(item.variance).toLocaleString() }}
                            </span>
                        </template>

                        <template v-slot:item.percentage="{ item }">
                            <v-chip
                            :color="item.percentage == 100 ? 'red' : 'green'"
                            size="small"
                            >
                            {{ item.percentage }}%
                            </v-chip>
                        </template>
                    </v-data-table>


                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </v-container>
    </v-container>
  </v-app>
</template>

<script setup>
import { ref, computed, onMounted,  watch, getCurrentInstance } from "vue";
import { useStore } from "vuex";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { toast } from "vue3-toastify";
import { formatDateDash } from "@/plugins/helpers";
import formattedDate from "@/plugins/dateFormatter";
import statusMap from "@/utils/statusMap";

// Store
const { proxy } = getCurrentInstance(); 
const store = useStore();

// Panels & Search
const panel = ref([0]);
const panel2 = ref([0]);
const search = ref("");
const itemsPerPage = ref(-1);
const loading = ref(false);

let $fileDate, $exportTableToPDF, $exportTableToExcel;
onMounted(() => {
  $fileDate = proxy.$fileDate;
  $exportTableToPDF = proxy.$exportTableToPDF;
  $exportTableToExcel = proxy.$exportTableToExcel;

  if (!$fileDate || !$exportTableToPDF || !$exportTableToExcel) {
    console.error("Export functions not loaded!");
  }
});

const reportData = computed(() => store.getters.getBudgetVarianceReport);

function getFinancialYearList() {
  const currentYear = new Date().getFullYear() - 1;
  const numberOfYears = 1;
  let years = [];
  for (let i = 0; i <= numberOfYears; i++) {
    const startYear = currentYear + i;
    years.push(`${startYear}`);
  }
  return years;
}

const { handleSubmit, setErrors } = useForm({
  validationSchema: yup.object({}),
});

// const { value: from_date, errorMessage: fromDateError } = useField("from_date");
// const { value: to_date, errorMessage: toDateError } = useField("to_date");
const { value: financial_year, errorMessage: financialYearError } = useField("financial_year");


const submit = handleSubmit(async (values) => {
  loading.value = true;
  const payload = {
    // from_date: formattedDate(from_date.value),
    // to_date: formattedDate(to_date.value),
    financial_year: financial_year.value,
  };
  try {
    await store.dispatch("getBudgetVarianceReport", payload);
  } catch (error) {
        const errors = error?.response?.data?.errors;
        if (errors) {
            const allErrors = Object.values(errors).flat().join("\n");
            toast.error(allErrors);
            const formattedErrors = {};
            Object.keys(errors).forEach(key => {
                formattedErrors[key] = errors[key][0];
            });
            setErrors(formattedErrors);
        } else {
            toast.error(error?.response?.data?.message || "An error occurred");
        }
  } finally {
    loading.value = false;
  }
});

// Table Headers
const headers = ref([
  { title: "#SL", key: "index", align: "center", width: "5%", sortable: false },
  { title: "Budget Type", key: "budget_type", align: "left" },
  { title: "Budget Head", key: "budget_head", align: "left" },
  { title: "Sub Head", key: "budget_sub_head", align: "left" },
  { title: "Budget", key: "budget", align: "right" },
  { title: "Actual", key: "actual", align: "right" },
  { title: "Variance", key: "variance", align: "right" },
  { title: "Variance %", key: "percentage", align: "right" },
]);

// Export Functions
const exportToPDF = () => {
  const columns = [
    "#SL", "Type", "Head", "Sub Head", "Budget", "Actual", "Variance", "%"
  ];

  let i = 1;
  const rows = reportData.value.map(item => [
    i++,
    item.budget_type,
    item.budget_head,
    item.budget_sub_head,
    item.budget,
    item.actual,
    item.variance,
    item.percentage + "%"
  ]);

  $exportTableToPDF(
    columns,
    rows,
    "Budget Variance Report",
    "budget_variance_" + $fileDate()
  );
};

const exportToExcel = () => {
  const data = [
    ["#SL", "Type", "Head", "Sub Head", "Budget", "Actual", "Variance", "Variance %"]
  ];

  let i = 1;
  reportData.value.forEach(item => {
    data.push([
      i++,
      item.budget_type,
      item.budget_head,
      item.budget_sub_head,
      item.budget,
      item.actual,
      item.variance,
      item.percentage + "%"
    ]);
  });

  $exportTableToExcel(data, "budget_variance_" + $fileDate());
};
</script>